import useIsMobile from '@/hooks/useIsMobile';
import WebsiteStatisticDesktop from './desktop';
import WebsiteStatisticMobile from './mobile';
import { WebsiteStatisticProvider, useWebsiteStattistic, useWebsiteStatisticScreen } from './useWebsiteStatistic';

const WebsiteStatisticContent = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useWebsiteStatisticScreen();

  if (isMobile) {
    return <WebsiteStatisticMobile viewModel={viewModel} />;
  }

  return <WebsiteStatisticDesktop viewModel={viewModel} />;
};

const WebsiteStatisticPage = () => {
  return (
    <WebsiteStatisticProvider>
      <WebsiteStatisticContent />
    </WebsiteStatisticProvider>
  );
};

export { useWebsiteStattistic };
export default WebsiteStatisticPage;